import { isThirdPartyIntegrations } from 'app/policies/config';
import { USER_ROLES } from 'app/services/users.service';

const userAllowed = ['apaez@santillana.com', 'mzunigap@unoi.com'];

function canPermissions(user) {
  return user?.role_guid !== USER_ROLES.publisher;
}

export function permissionsRol(user) {
  return {
    readList: canPermissions(user),
    readDetail: canPermissions(user),
    create: canPermissions(user) && !isThirdPartyIntegrations(user),
    update: canPermissions(user) && !isThirdPartyIntegrations(user),
    delete: canPermissions(user) && !isThirdPartyIntegrations(user),

    // TABLE USERS:
    columnAdminSchool: !isThirdPartyIntegrations(user),

    // DETAIL USER:
    tabPassword: true,
    tabLicenses: true,
    tabAdminSchool: !isThirdPartyIntegrations(user),
    showUploadAvatar: !isThirdPartyIntegrations(user),
    submitDetail: true,
    updateDetail: !isThirdPartyIntegrations(user),

    // TAB LICENCES:
    tabLicensesCreate: !isThirdPartyIntegrations(user),
    deleteUserLicenses: !isThirdPartyIntegrations(user),
  };
}
